module.exports = __webpack_public_path__ + "media/images/newDownload-6f0d3c3b.png";